import ExlyTable from "common/Components/ExlyTable";
import React, { useEffect } from "react";
import { RESOURCE_KEYS, orgPermissions } from "utils/OrgPermissions";
import {
  filterConfig,
  getTableConfig,
  tableChipsFormatter,
} from "./constants/disputeTableConfig";
import { exportLargeListingData } from "utils/Utils";
import { REPORT_TYPES } from "ui/pages/Reports/constants";
import { useNotifications } from "utils/hooks";
import { WhatsAppButton } from "webpage-leads/components/CustomColumns";
import { FilteredEmptyState } from "../AllTransaction/components/TableFields/TableFields";
import {
  ACTION_ELIGIBLE_STATUSES,
  emptyStateProps,
  FIELD_DATA,
  HEADER_NOTE,
  DISPUTE_HISTORY,
} from "./constants/disputes.constant";
import { getTransactionsTabConfig } from "features/Crm/modules/Transactions/utils/Transactions.utils";
import { StatusField } from "./TableFields/TableFields";
import { InitiateDisputeModal } from "../AllTransaction/components/InitiateDisputeModal/InitiateDisputeModal";
import { useDisputeModal } from "../AllTransaction/components/InitiateDisputeModal/store/useDisputeModal";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { DisputeConfirmationModal } from "../AllTransaction/components/DisputeConfirmationModal/DisputeConfirmationModal";
import { DisputePaymentModal } from "../AllTransaction/components/DisputePaymentModal/DisputePaymentModal";
import {
  MoreActionsButton,
  PrimaryActionField,
} from "./CustomActions/CustomActions";
import { getRAUrlParams } from "features/Common/utils/url.utils";
import { URL_PARAMS_KEYS } from "features/Common/modules/Urls&Routing/constants/URL.constant";
import { useDisputeHistory } from "./utils/useDisputeHistory";
import { useRefresh } from "react-admin";
import { PaymentStatusModal } from "utils/Payments/PaymentStatusModal";
import { is_empty } from "features/Common/utils/common.utils";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";

export const DisputeHistory = withComponentLibraryTheme((props) => {
  const { notify } = useNotifications();
  const refresh = useRefresh();

  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const selectedRecord = useDisputeModal((state) => state.selectedRecord);
  const setSelectedRecord = useDisputeModal((state) => state.setSelectedRecord);
  const setIsDisputePaymentSuccess = useDisputeModal(
    (state) => state.setIsDisputePaymentSuccess
  );
  const setisOpenInitiateDisputeModal = useDisputeModal(
    (state) => state.setisOpenInitiateDisputeModal
  );
  const {
    disputePaymentStatusCheck,
    setOrderId,
    getMoreActions,
    getDisputeRecordByTransactionId,
  } = useDisputeHistory();
  const isCustomerDetailsHidden = orgPermissions.isNavigationItemHidden(
    RESOURCE_KEYS.SECTIONS.ALL_CUSTOMERS
  );

  // represents the current status of payment for dispute payment
  const [payment_status, set_payment_status] = React.useState(null);
  const [transactionId, setTransactionId] = React.useState(null);

  // on successful transaction completion, show the confirmation modal
  useEffect(() => {
    // read orderId from URL after redirect from payment gateway
    const fetchedOrderId = getRAUrlParams()?.get(URL_PARAMS_KEYS.transaction);
    if (!is_empty(fetchedOrderId)) {
      // fetching payment status for the given orderId
      setOrderId(fetchedOrderId);
      set_payment_status(disputePaymentStatusCheck?.order?.status);
      if (disputePaymentStatusCheck?.order?.status) {
        setTransactionId(getRAUrlParams()?.get(URL_PARAMS_KEYS.transactionId));
        setIsDisputePaymentSuccess(true);
        refresh();
      }
    }
  }, [disputePaymentStatusCheck]);

  useEffect(() => {
    if (transactionId && !payment_status) {
      setSelectedRecord([getDisputeRecordByTransactionId({ transactionId })]);
      setisOpenInitiateDisputeModal(true);
    }
  }, [payment_status]);

  return (
    <>
      <div className="component-wrapper">
        <ExlyTable
          ra_props={{
            ...props,
          }}
          noExportButton={!orgPermissions.canExport()}
          tableTitle={
            <div>
              <h1 className="tw-text-[18px] tw-font-bold tw-mb-[8px]">
                {HEADER_NOTE.dispute_title}
              </h1>
              <div className="tw-text-[12px] tw-text-[#2e3033] tw-font-light tw-leading-[14.32px]">
                {HEADER_NOTE.dispute_sub_heading}
              </div>
            </div>
          }
          tabConfig={getTransactionsTabConfig({ isWalletActive })}
          selectedTab={DISPUTE_HISTORY}
          columnConfig={getTableConfig}
          tableChipsFormatter={tableChipsFormatter()}
          layoutProps={{
            paddingDesktop: "0",
            paddingMobile: "0",
            paddingBottom: "68px",
            noMobileBoxShadow: true,
            showFixedBars: true,
          }}
          customHandleExport={({ filterValues, isEmpty }) =>
            exportLargeListingData({
              filterValues,
              reportType: REPORT_TYPES.DISPUTE_HISTORY,
              notify,
              isEmpty,
            })
          }
          renderPrimaryColumnRightNode={(record) => {
            return (
              <>
                {is_empty(record.customer_phone) ||
                isCustomerDetailsHidden ? null : (
                  <WhatsAppButton
                    record={record}
                    source="customer_phone"
                    countryCodeKey="country_code"
                  />
                )}
              </>
            );
          }}
          filteredEmptyState={<FilteredEmptyState />}
          borderedFields
          fieldsLeftPadded
          drawerFieldsBordered
          fieldsAlignment="space-between"
          drawerFieldsAlignment="space-between"
          recordFooterVariant="secondary"
          primaryActions={getMoreActions({
            record: selectedRecord ? selectedRecord[0] : null,
          })}
          renderSecondaryAction={(record) => (
            <div className="tw-w-full tw-flex tw-justify-start tw-mr-[15px]">
              <StatusField record={record} source={FIELD_DATA.status} />
            </div>
          )}
          customPrimaryAction={{
            renderCustomAction: (
              record,
              rows,
              setDrawerConfig,
              setActionsDrawerConfig
            ) =>
              ACTION_ELIGIBLE_STATUSES.includes(record?.status) && (
                <MoreActionsButton
                  label="More Actions"
                  onClick={() => {
                    setSelectedRecord([record]);
                    setActionsDrawerConfig({ row: record, open: true });
                  }}
                />
              ),
            onClose: (row, rows, setDrawerConfig, setActionsDrawerConfig) => {
              setActionsDrawerConfig((prevState) => ({
                ...prevState,
                open: false,
              }));
            },
          }}
          primaryColumnProps={{
            align: "center",
            sticky: true,
            title: "Action",
            className: "!tw-p-[0_24px]",
          }}
          desktopCustomPrimaryAction={{
            renderCustomAction: (row, rows, setAnchorEl, setOpenPopper) =>
              ACTION_ELIGIBLE_STATUSES.includes(row?.status) && (
                <PrimaryActionField
                  onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                    setOpenPopper(true);
                    setSelectedRecord([row]);
                  }}
                />
              ),
          }}
          tableFilters={filterConfig()}
          {...emptyStateProps}
        />
      </div>
      <InitiateDisputeModal value={{ selectedRecords: selectedRecord }} />
      <DisputeConfirmationModal value={{ selectedRecords: selectedRecord }} />
      <DisputePaymentModal value={{ selectedRecords: selectedRecord }} />
      {!is_empty(payment_status) && (
        <PaymentStatusModal
          payment_status={payment_status}
          set_payment_status={set_payment_status}
        />
      )}
    </>
  );
});
